import React, { useState } from "react";
import axios from "axios";

const MedicalReport = () => {
  const [passportNumber, setPassportNumber] = useState("");
  const [isValid, setIsValid] = useState(null);
  const [errorMessage, setErrorMessage] = useState(""); // To handle errors
  const [reportLink, setReportLink] = useState(""); // Store the medical report link

  const handleDownloadReport = () => {
    if (reportLink) {
      // Open the report link in a new tab (or handle downloading)
      window.open(reportLink, "_blank");
    } else {
      alert("No report available to download.");
    }
  };
  const apiUrl = import.meta.env.VITE_API_URL;
  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorMessage(""); // Reset error message on submit
    setIsValid(null); // Reset validation
    setReportLink(""); // Clear previous report link

    try {
      // Make API call to fetch the medical report
      const response = await axios.get(
        `${apiUrl}/medical-reports/${passportNumber}/`
      );

      // Log the response to check its structure
      console.log(response.data);

      // If successful, check if medical_report exists in the response
      if (response.data && response.data.medical_report) {
        setReportLink(response.data.medical_report); // Set the report link
        setIsValid(true);
      } else {
        throw new Error("Report not found");
      }
    } catch (error) {
      // Handle error, if the passport number is not found or any other error
      setErrorMessage("No medical report found for this passport number.");
      setIsValid(false);
    }
  };

  const handleInputChange = (e) => {
    setPassportNumber(e.target.value);
    setIsValid(null); // Reset the validation message when user starts typing
  };

  return (
    <div className="bg-black lg:min-h-screen flex items-center justify-center px-5 py-10">
      <div className="bg-black shadow-2xl rounded-lg max-w-3xl w-full p-10 border-4 border-[#e6b800]">
        <h2 className="text-2xl lg:text-4xl font-bold text-center text-white mb-6">
          Check Your Medical Report
        </h2>
        <p className="text-center text-gray-300 mb-8 text-MD lg:text-lg">
          Enter your passport number below to view and download your medical report instantly.
        </p>

        {/* Passport Number Form */}
        <form onSubmit={handleSubmit} className="space-y-6">
          {/* Passport Number Input */}
          <div>
            <label
              className="block text-white font-medium mb-2 text-xl"
              htmlFor="passport-number"
            >
              Passport Number
            </label>
            <input
              type="text"
              id="passport-number"
              className="text-lg w-full px-4 py-3 border border-gray-600 rounded-lg bg-black text-white focus:outline-none focus:ring-4 focus:ring-[#e6b800] placeholder-gray-500"
              placeholder="Enter your passport no."
              value={passportNumber}
              onChange={handleInputChange}
              required
            />
          </div>

          {/* Submit Button */}
          <button
            type="submit"
            className="w-full bg-[#e6b800] text-black py-3 rounded-lg font-bold text-2xl hover:bg-black hover:text-[#e6b800] border-2 border-[#e6b800] transition duration-300"
          >
            View Report
          </button>
        </form>

        {/* Report Download Section */}
        {isValid !== null && (
          <div className="mt-8">
            {isValid ? (
              <div className="bg-black border-2 border-[#e6b800] rounded-lg p-6 space-y-4">
                <h3 className="text-2xl font-bold text-white mb-4">
                  Medical Report Found
                </h3>
                <div className="flex justify-center mt-4">
                  <button
                    className="bg-[#e6b800] text-black px-4 py-2 rounded-lg font-bold hover:bg-black hover:text-[#e6b800] transition duration-300"
                    onClick={handleDownloadReport}
                  >
                    Download Report
                  </button>
                </div>
              </div>
            ) : (
              <div className="text-center text-red-500">
                <p>{errorMessage}</p>
              </div>
            )}
          </div>
        )}

       

        {/* Decorative Elements */}
        <div className="absolute inset-0 pointer-events-none">
          <div className="absolute -top-6 left-10 h-16 w-16 bg-[#e6b800] rounded-full blur-3xl opacity-20"></div>
          <div className="absolute bottom-6 right-10 h-24 w-24 bg-[#e6b800] rounded-full blur-3xl opacity-20"></div>
        </div>
      </div>
    </div>
  );
};

export default MedicalReport;
